import React, {useEffect, useState} from 'react';
import {Box, Stack} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useApiGetSchedaCostoDetail from "./api-hooks/useApiGetSchedaCostoDetail";
import SchedaCostoRawMaterialCard from "./SchedaCostoRawMaterialCard";
import SchedaFinalMeasurementCard from "./SchedaFinalMeasurementCard";
import SchedaCostoTanneryDyeingCard from "./SchedaCostoTanneryDyeingCard";
import SchedaCostoWorkingsCard from "./SchedaCostoWorkingsCard";
import SchedaCostoVociCard from "./SchedaCostoVociCard";
import SchedaCostoSummaryCard from "./SchedaCostoSummaryCard";
import MuiFabButtonBack from "../../../../../ui/mui/mui_buttons/fab/extended/MuiFabButtonBack";
import useApiCreateSchedaCosto from "./api-hooks/useApiCreateSchedaCosto";
import {useToast} from "../../../../../../utils/contexts/toast-context";
import {useQueryClient} from "@tanstack/react-query";
import MuiModal from "../../../../../ui/mui/mui_modal/MuiModal";
import SchedaCostoForm from "./SchedaCostoForm";
import MuiFabButtonEdit from "../../../../../ui/mui/mui_buttons/fab/MuiFabButtonEdit";

interface Props {
    order_id?: number;
    onClose: () => void;
}

const SchedaCostoCard = ({order_id, onClose}: Props) => {
    const theme = useTheme();
    const {displayMessage, displayError} = useToast();
    const queryClient = useQueryClient();

    const {data: detailedObj, isSuccess, isFetched} = useApiGetSchedaCostoDetail(order_id);

    const [isEdiFormOpen, setIsEditFormOpen] = useState(false);

    const createMutation = useApiCreateSchedaCosto();
    const [isCreating, setIsCreating] = useState(false);
    useEffect(() => {
        const createIfNotFound = async () => {
            if (isFetched && !detailedObj && order_id && !isCreating) {
                setIsCreating(true);
                try {
                    const mutation_data = {
                        order_id: order_id,
                    };
                    const newObj = await createMutation.mutateAsync(mutation_data);
                    displayMessage('added successfully');
                    await queryClient.invalidateQueries({queryKey: ['getCompanyOrderSchedule']});

                    // Invalidate queries to reload the newly created object
                    await queryClient.invalidateQueries({queryKey: ['useApiGetSchedaCostoDetail', order_id]});
                } catch (error) {
                    displayError('Error creating scheda costo');
                } finally {
                    setIsCreating(false);
                }
            }
        };

        createIfNotFound();
    }, [isFetched, detailedObj, order_id, isCreating]);

    return (
        <Box sx={{padding: 2}}>
            <Box sx={{display: 'flex', justifyContent: 'center', marginBottom: 2, gap: 2}}>
                <MuiFabButtonBack onClick={onClose}/>
                <MuiFabButtonEdit onClick={() => setIsEditFormOpen(true)}/>
            </Box>
            <Stack direction={{xs: "column", md: "row"}} spacing={2}>
                <Stack direction="column" spacing={2} flex={1}>
                    <Box>
                        <SchedaCostoSummaryCard order_id={detailedObj?.order.id}/>
                    </Box>
                    <Box>
                        <SchedaCostoRawMaterialCard order_id={detailedObj?.order.id}/>
                    </Box>
                    <Box>
                        <SchedaFinalMeasurementCard order_id={detailedObj?.order.id}/>
                    </Box>
                </Stack>

                <Stack direction="column" spacing={2} flex={1}>
                    <Box>
                        <SchedaCostoTanneryDyeingCard order_id={detailedObj?.order.id}/>
                    </Box>
                    <Box>
                        <SchedaCostoWorkingsCard order_id={detailedObj?.order.id}/>
                    </Box>
                    <Box>
                        <SchedaCostoVociCard order_id={detailedObj?.order.id}/>
                    </Box>
                </Stack>
            </Stack>


            <MuiModal top="50%" left="50%" width={'95%'} height={'95%'}
                      open={isEdiFormOpen}
                      disableBackdropClick={true}
                      onClose={() => setIsEditFormOpen(false)}>
                <SchedaCostoForm
                    order_id={order_id}
                    onClose={() => setIsEditFormOpen(false)}
                />
            </MuiModal>


        </Box>
    );
}

export default SchedaCostoCard;